import * as globals from '@wandb/weave/common/css/globals.styles';
import {Link} from '@wandb/weave/common/util/links';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {
  IconFolderProject,
  IconRecentClock,
  IconRunningRepeat,
  IconUserProfilePersonal,
  IconUsersTeam,
} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

// @todo: Migrate to 'Skeleton' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Skeleton} from '../../../components/Skeleton';
import {BREAKPOINT_TWO_COL_PX, cardContent} from './CommonCards.styles';

const BREAKPOINT_MOBILE = 450;

const iconStyles = css`
  width: 18px;
  height: 18px;
`;

export const RunsIcon = styled(IconRunningRepeat)`
  ${iconStyles};
`;

export const UpdatedAtIcon = styled(IconRecentClock)`
  ${iconStyles};
`;

export const IconTeam = styled(IconUsersTeam)`
  ${iconStyles};
`;

export const IconUser = styled(IconUserProfilePersonal)`
  ${iconStyles};
`;

export const FolderProjectIcon = styled(IconFolderProject)`
  ${iconStyles};
`;

const clampStyles = css`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: nowrap;
`;

export const CardLeft = styled.div`
  ${clampStyles};
  display: flex;
  align-content: flex-start;
  align-items: center;
  gap: 16px;
  margin-right: 10px;
  grid-area: left;
  @media (max-width: ${BREAKPOINT_MOBILE}px) {
    white-space: wrap;
    align-items: flex-start;
  }
`;

export const CardInnerLeft = styled.div`
  display: flex;
  gap: 16px;
  @media (max-width: ${BREAKPOINT_TWO_COL_PX}px) {
    justify-content: left;
  }
  @media (max-width: ${BREAKPOINT_MOBILE}px) {
    justify-content: left;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

export const SkeletonPill = styled(Skeleton)`
  border-radius: 1rem;
  width: 50px;
`;

export const CardInnerRight = styled.div`
  display: flex;
  gap: 16px;
  @media (max-width: ${BREAKPOINT_TWO_COL_PX}px) {
    justify-content: right;
    width: 100%;
  }
`;
export const CardRight = styled.div`
  ${clampStyles};
  display: flex;
  justify-content: left;
  flex: 1;
  gap: 10px;
  align-items: center;
  color: ${globals.MOON_500};
  font-family: Source Sans Pro;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  grid-area: right;
  @media (max-width: ${BREAKPOINT_MOBILE}px) {
    white-space: wrap;
  }
`;

export const Card = styled(Link)`
  display: flex;
  flex: 1;
  ${cardContent}
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-gap: 10px;
  margin-bottom: 40px;
`;

export const InnerGrid = styled.div`
  display: grid;
  justify-content: right;
  width: 100%;
  grid-template-columns: minmax(0, 1fr);
  grid-gap: 5px;
  grid-template-areas: 'left right';
  @media (max-width: ${BREAKPOINT_TWO_COL_PX}px) {
    grid-template-areas:
      'left left'
      'right right';
  }
`;

export const UpdatedAt = styled.div`
  color: ${globals.MOON_500};
  font-family: Source Sans Pro;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const CardHeader = styled.div`
  color: ${globals.MOON_950}
  display: block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: Source Sans Pro;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const ProjectName = styled.div`
  display: block;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ActivityIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;
